import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  Typography,
  Button,
  Space,
  message,
  Input,
  Row,
  Col,
  Divider,
  Avatar,
} from "antd";
import {
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  SafetyOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function MPinPage() {
  const [pin, setPin] = useState(["", "", "", "", "", ""]);
  const [showPin, setShowPin] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const { mpin } = useSelector((state) => state.auth);
  const { role } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleInputChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  console.log("role", role);
  const authenticatedRoutes = () => {
    if (role === "MASTER" || role === "CHIEF_ENGINEER") {
      return navigate("/admin");
    } else if (role === "ENGINE_ROOM" || role === "BRIDGE") {
      return navigate("/user");
    } else if (role === "SUPERADMIN") {
      return navigate("/superadmin");
    } else if (
      role === "OWNER" ||
      role === "OWNERGROUP" ||
      role === "FLEET_MANAGER" ||
      role === "VESSEL_MANANGER"
    ) {
      return navigate("/management");
    } else {
      navigate("/login");
    }
  };
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }

    if (e.key === "v" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      navigator.clipboard.readText().then((text) => {
        const digits = text.replace(/\D/g, "").slice(0, 6);
        const newPin = [...pin];
        for (let i = 0; i < 6; i++) {
          newPin[i] = digits[i] || "";
        }
        setPin(newPin);

        const nextIndex = Math.min(digits.length, 5);
        inputRefs.current[nextIndex]?.focus();
      });
    }
  };

  const handleSubmit = async () => {
    const pinValue = pin.join("");
    setLoading(true);

    if (pinValue.length !== 6) {
      message.error("Please enter a complete 6-digit PIN");
      return;
    }
    if (pinValue === mpin) {
      message.success("PIN verified successfully!");
      authenticatedRoutes();
    } else {
      message.error("Wrong MPin");
      console.log("wrong pin");
    }
    setLoading(false);
  };
 

  const isPinComplete = pin.every((digit) => digit !== "");

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "linear-gradient(315deg, #27a770 0%, #efefef 74%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: "420px",
          borderRadius: "16px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          border: "none",
        }}
        bodyStyle={{ padding: "40px 32px" }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <Avatar
            size={64}
            style={{
              backgroundColor: "#27a770",
              marginBottom: "16px",
            }}
            icon={
              <SafetyOutlined style={{ color: "white", fontSize: "28px" }} />
            }
          />
          <Title level={2} style={{ margin: "0 0 8px 0", color: "#262626" }}>
            Secure Login
          </Title>
          <Text type="secondary" style={{ fontSize: "15px" }}>
            Enter your 6-digit MPIN to access your account
          </Text>
        </div>

        <div style={{ marginBottom: "32px" }}>
          <Row gutter={12} justify="center" style={{ marginBottom: "16px" }}>
            {pin.map((digit, index) => (
              <Col key={index}>
                <Input
                  ref={(el) => (inputRefs.current[index] = el)}
                  value={digit}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  maxLength={1}
                  style={{
                    width: "48px",
                    height: "48px",
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    border: digit
                      ? "2px solidrgb(61, 158, 116)"
                      : "2px solid #d9d9d9",
                  }}
                  type={showPin ? "text" : "password"}
                  inputMode="numeric"
                />
              </Col>
            ))}
          </Row>

          <div style={{ textAlign: "center" }}>
            <Button
              type="text"
              icon={showPin ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              onClick={() => setShowPin(!showPin)}
              style={{ color: "#8c8c8c", fontSize: "14px" }}
            >
              {showPin ? "Hide" : "Show"} PIN
            </Button>
            <Button
              type="text"
               onClick={() => navigate("/setup")}
              style={{ color: "#8c8c8c", fontSize: "14px" }}
            >
              Forget PIN
            </Button>
          </div>
        </div>

        <Divider style={{ margin: "24px 0" }} />

        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Button
            type="primary"
            size="large"
            block
            loading={loading}
            disabled={!isPinComplete}
            onClick={handleSubmit}
            style={{
              height: "48px",
              fontSize: "16px",
              fontWeight: "500",
              borderRadius: "8px",
            }}
            icon={<LockOutlined />}
          >
            {loading ? "Verifying PIN..." : "Verify & Continue"}
          </Button>
        </Space>
      </Card>
    </div>
  );
}
